import React, { Component } from "react";
import { Button, Card, Spin, Select, Input, List as antList, Icon, Tooltip } from "antd";
import { Table } from "components/table";
import { CAMS_VIEW_COLUMNS_NEW } from "../../constants/columns";
import PropTypes from "prop-types";
import { STATE_STATUS } from "../../constants";
import { List, OrderedMap } from "immutable";
import { CaseService } from "../../services";
import CreditSummaryCams from "./credit-summary-cams"

const onCellGenerator = (handleSave, _) => record => {
    return ({
        record,
        editable: true,
        dataIndex: _.dataIndex,
        title: record.header || _.title,
        handleSave,
        rules: record.rules || _.rules,
        fieldType: record.fieldType || _.fieldType,
        filesMultiple: _.filesMultiple ? _.filesMultiple : false,
        options: record.options || _.options,
        // getFileUploadParams: _.getFileUploadParams,
        // uploadTarget: _.uploadTarget,
        viewable: true,
        max: record.max
    })
};


class CAMViewNew extends Component {
    updateReplyButtonRef = React.createRef();
    state = {
        camEngineTableData: [],
        newData: new OrderedMap({}),
        canDataLoader: false,
        submittedComments: {},
        editInfo: null,
        selectedFactNameMap: {},
        commentTextMap: {},
        replyTexts: {},
        replyEditInfo: null,
        creditSummaryData: null,
        camViewCommentsData: []
    }

    componentDidMount() {
        // this.props.fetchCamEngineView(this.props.caseId);
        CaseService.getCamViewCreditSummary(this.props.caseId).then(res => {
            this.setState({ creditSummaryData: res?.data?.result?.choices[0].message?.content });
        }).catch(err => {
            console.error('Error fetching summary:', err);
        });
        if (this.props.camEngineStatus === STATE_STATUS.FETCHED) {
            this.creditEnhancementDbViewFn();
        } else {
            this.props.fetchCamEngineView(this.props.caseId);
        }

        if (this.props.camEngineCommentsStatus === STATE_STATUS.FETCHED) {
            this.camViewCommentsFn();
        } else {
            this.props.fetchCamEngineViewComments(this.props.caseId);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.camEngineStatus == STATE_STATUS.FETCHED && prevProps.camEngineStatus == STATE_STATUS.FETCHING) {
            this.creditEnhancementDbViewFn();
        }
        if (this.props.camEngineCommentsStatus == STATE_STATUS.FETCHED && prevProps.camEngineCommentsStatus == STATE_STATUS.FETCHING) {
            this.camViewCommentsFn();
        }
    }

    groupByCategory(data, order) {
        const groupedData = {};

        // Initialize groupedData with empty arrays for each category in order
        order.forEach(category => {
            groupedData[category] = [];
        });

        // Group items by category
        data.forEach(item => {
            const category = item.category;
            if (groupedData.hasOwnProperty(category)) {
                groupedData[category].push(item);
            }
        })
        return groupedData;
    }

    groupByTableTitle = (data) => {

        const categoryTitleMap = {
            General: "Applicant Profile",
            GST: "GSTIN Analysis",
            Bureau: "Bureau Assessment",
            MPA: "Anchor Relationship",
            Anchor: "Anchor Relationship",
            Ledger: "Ledger",
            Banking: "Banking",
            Financials: "Financials",
            DB: "Portfolio Performance",
            Geography: "Portfolio Performance",
        };

        const grouped = {};

        data.forEach(item => {
            const title = categoryTitleMap[item.category] || "Others";
            if (!grouped[title]) {
                grouped[title] = [];
            }
            grouped[title].push(item);
        });
        return grouped;
    };

    groupCommentsByTableTitle = (commentsData = []) => {
        const categoryTitleMap = {
            General: "Applicant Profile",
            GST: "GSTIN Analysis",
            Bureau: "Bureau Assessment",
            MPA: "Anchor Relationship",
            Anchor: "Anchor Relationship",
            Ledger: "Ledger",
            Banking: "Banking",
            Financials: "Financials",
            DB: "Portfolio Performance",
            Geography: "Portfolio Performance",
        };

        const grouped = {};

        commentsData.forEach(section => {
            const title = categoryTitleMap[section.title] || section.title;
            if (!grouped[title]) grouped[title] = [];

            section.comments.forEach(comment => {
                grouped[title].push({
                    ...comment,
                    factName: comment.fact_name,
                    comment: comment.comment,
                    replies: comment.replies || [],
                    created_by: comment.created_by_name || [],
                });
            });
        });
        return grouped;
    };


    creditEnhancementDbViewFn = () => {
        const camsApiData = this.props.camEngineData;
        for (let key in camsApiData) {
            if (camsApiData.hasOwnProperty(key)) {
                // Add the key property to each nested object
                camsApiData[key].key2 = key;
            }
        }
        const sortedData = camsApiData && Object.entries(camsApiData).sort(([keyA], [keyB]) => {
            const lastPartA = keyA.split('_').pop();
            const lastPartB = keyB.split('_').pop();

            const isIntA = !isNaN(lastPartA);
            const isIntB = !isNaN(lastPartB);

            if (isIntA && isIntB) {
                return parseInt(lastPartA) - parseInt(lastPartB);
            } else if (isIntA) {
                return 1;
            } else if (isIntB) {
                return -1;
            } else {
                return 0;
            }
        });
        const sortedObject = Object.fromEntries(sortedData);
        const CamViewDataApi = camsApiData && Object.values(sortedObject);
        const camsViewData = [];
        CamViewDataApi.forEach((el, idx) => {
            if (el?.category) {
                const factValue =
                    el?.fact_value === true
                        ? "True"
                        : (el?.fact_value === false || el?.fact_value === "" || el?.fact_value === null)
                            ? "False"
                            : el?.fact_value;
                camsViewData.push({
                    "s_no": idx + 1,
                    "category": el?.category,
                    "fact_name": el?.fact_name,
                    "fact_value": typeof factValue === 'string' && factValue.length > 30 ? (
                        <Tooltip title={factValue}>
                            <span>{factValue.slice(0, 30) + '...'}</span>
                        </Tooltip>
                    ) : (
                        factValue
                    ),
                    "policy": typeof el?.policy == "boolean" ? String(el?.policy) : el?.policy || "NA",
                    "output": el?.output == true ? "Pass" : el?.output == false ? "Fail" : "Not Applicable",
                })
            };
        });
        const groupedByTableTitle = this.groupByTableTitle(camsViewData);

        // const commentsData = this.props.camEngineData?.comments_replies_data || [];
        // const groupedComments = this.groupCommentsByTableTitle(commentsData);

        this.setState({
            groupedCamData: groupedByTableTitle,
            // submittedComments: groupedComments,
            newData: new OrderedMap(camsApiData),
        });
    }

    camViewCommentsFn = () => {
        const commentsData = this.props.camEngineCommentsData?.comments_replies_data || [];
        const groupedComments = this.groupCommentsByTableTitle(commentsData);
        this.setState({
            submittedComments: groupedComments,
        });
    }

    getCustomTag = (_, key) => {
        if (key == "deviation") {
            return <label className="br-4" style={{ backgroundColor: _ === "Yes" ? "#f4f494" : "" }}> {_} </label>
        }
        return <div style={{ width: "100%" }}><label
            className="txt-light br-4"
            style={{ backgroundColor: _ === "Pass" ? "rgb(134 220 134)" : _ === "Fail" ? "rgb(238 142 142)" : "rgb(226 226 30)", padding: "0 10px 0 10px", display: "inline-block", width: "70%" }}
        >
            {_}
        </label></div>
    }
    approveCase = () => {
        this.setState({
            canDataLoader: true
        })
        CaseService.approveCamsCase(this.props.caseId)
            .then((resp) => {
                this.setState({
                    canDataLoader: false
                })
            })
            .catch((err) => {
                this.setState({
                    canDataLoader: false
                })
                console.log(err);
            })
    }

    handleSaveMultipleEntries = (record, values) => {
        if ((record.key || record.key == 0) && this.state.newData.size) {
            let data = this.state.newData.map((_, k) => {
                if (_.key2 == record.key2) {
                    return {
                        ..._,
                        ...values,
                        key: record.key
                    };
                }
                return _;
            });
            this.setState({
                newData: data
            });
        }
    }

    handleEditComment = (title, index) => {
        const commentData = this.state.submittedComments[title][index];
        this.setState(prevState => ({
            selectedFactNameMap: {
                ...prevState.selectedFactNameMap,
                [title]: commentData.factName,
            },
            commentTextMap: {
                ...prevState.commentTextMap,
                [title]: commentData.comment,
            },
            editInfo: { title, index },
        }));
    };


    handleCommentSubmit = (title) => {
        const { selectedFactNameMap, commentTextMap, submittedComments, editInfo } = this.state;
        const selectedFactName = selectedFactNameMap[title];
        const commentText = commentTextMap[title];

        if (!selectedFactName || !commentText) return;

        const isEdit = !!editInfo && editInfo.title === title;
        const commentPayload = {
            title,
            fact_name: selectedFactName,
            comment: commentText,
            ...(isEdit && { comment_id: submittedComments[title][editInfo.index].id }),
        };

        this.submitCamViewComments(commentPayload, isEdit ? 'patch' : 'post');

        this.setState(prevState => ({
            selectedFactNameMap: {
                ...prevState.selectedFactNameMap,
                [title]: null,
            },
            commentTextMap: {
                ...prevState.commentTextMap,
                [title]: '',
            },
            editInfo: null,
        }));
    };



    handleReplyInputChange = (e, title, commentIndex) => {
        const key = `${commentIndex}_${title}`;
        this.setState({
            replyTexts: {
                ...this.state.replyTexts,
                [key]: e.target.value,
            },
        });
    };

    handleReplySubmit = (title, commentIndex) => {
        const key = `${commentIndex}_${title}`;
        const replyText = this.state.replyTexts[key];
        const comment = this.state.submittedComments[title][commentIndex];

        if (!replyText) return;

        const isEdit = this.state.replyEditInfo?.replyIndex != null;
        const replyPayload = {
            title,
            comment_id: comment.id,
            reply: replyText,
            ...(isEdit && {
                reply_id: comment.replies[this.state.replyEditInfo.replyIndex].id
            })
        };
        this.submitCamViewComments(replyPayload, isEdit ? 'patch' : 'post');

        this.setState({
            replyTexts: { ...this.state.replyTexts, [key]: '' },
            replyEditInfo: null,
            activeReply: null
        });
    };


    submitCamViewComments = (payload, method = 'post') => {
        const { caseId } = this.props;
        const apiCall = method === 'patch'
            ? CaseService.updateCamViewComments(caseId, payload)
            : CaseService.saveCamViewComments(caseId, payload);

        apiCall
            .then(res => {
                // this.props.fetchCamEngineView(this.props.caseId);
                this.props.fetchCamEngineViewComments(this.props.caseId);
            })
            .catch(err => {
                console.error("Error saving/updating comments:", err);
            });
    };



    handleEditReply = (title, commentIndex, replyIndex, currentReply) => {
        const key = `${commentIndex}_${title}`;
        this.setState({
            replyTexts: {
                ...this.state.replyTexts,
                [key]: currentReply,
            },
            activeReply: {
                title,
                commentIndex,
            },
            replyEditInfo: {
                title,
                commentIndex,
                replyIndex,
            },
        }, () => {
            if (this.updateReplyButtonRef.current) {
                this.updateReplyButtonRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        });
    };


    render() {
        return (
            <>
                <Spin spinning={this.props.camEngineStatus === STATE_STATUS.FETCHING || this.state.canDataLoader}>
                    <Card
                        headStyle={{ display: 'none' }}
                        extra={[
                            // <Button type={"link"} onClick={() => this.refreshCamData()} key="refresh">
                            //     Refresh
                            // </Button>,
                            // <Button type={"link"} onClick={() => this.updateDetails()} key="update">
                            //     Update
                            // </Button>
                        ]}>
                        <div className="d-flex justify-content-space-between">
                            <h2>Credit Insight Dashboard</h2>
                            <Button type="primary" onClick={() => this.approveCase()} key="approve"
                                style={{ backgroundColor: "#46b046", border: "none" }}
                            >
                                <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" /> Approve
                            </Button>
                        </div>
                    </Card>
                    <br />
                    {this.state.creditSummaryData && <CreditSummaryCams creditSummaryData={this.state.creditSummaryData} />}
                    <br />
                    {Object.entries(this.state.groupedCamData || {}).map(([title, rows]) => (
                        <div key={title} className="w-80" style={{ margin: "0 auto", marginBottom: "1.5rem" }}>
                            <Card style={{ border: "0", backgroundColor: "rgb(237, 241, 255)" }}>
                                <h3>{title}</h3>
                                <Table
                                    className="p-10 ant-col padless-card custom-align-table-body-cam"
                                    columns={CAMS_VIEW_COLUMNS_NEW(this.getCustomTag).map(({ editable, ...rest }) => {
                                        if (!onCellGenerator || !editable) return rest;
                                        return {
                                            onCell: onCellGenerator(this.handleSaveMultipleEntries, rest),
                                            ...rest,
                                        };
                                    })}
                                    data={List(rows).toList()}
                                    size="middle"
                                    pagination={false}
                                    // showTopSection={false}
                                    showFilters={false}
                                    noRowSelection={true}
                                    showColumnSelector={false}
                                    scrollY={500}
                                />
                                <Select
                                    placeholder="Select a Parameter"
                                    style={{ width: '100%', marginBottom: '10px' }}
                                    mode="multiple"
                                    onChange={(value) =>
                                        this.setState(prevState => ({
                                            selectedFactNameMap: {
                                                ...prevState.selectedFactNameMap,
                                                [title]: value,
                                            },
                                            commentTextMap: {
                                                ...prevState.commentTextMap,
                                                [title]: '',
                                            },
                                        }))
                                    }
                                    value={this.state.selectedFactNameMap?.[title] || undefined}
                                >
                                    {[...new Set(this.state.groupedCamData && this.state.groupedCamData[title].filter(el => el.output === "Fail").map(item => item.fact_name))]
                                        .map(factName => (
                                            <Select.Option key={factName} value={factName}>
                                                {factName}
                                            </Select.Option>
                                        ))}
                                </Select>
                                <Input.TextArea
                                    placeholder="Add your comments here..."
                                    disabled={!this.state.selectedFactNameMap?.[title]}
                                    value={this.state.commentTextMap?.[title] ?? ''}
                                    onChange={(e) => {
                                        const value = e?.target?.value ?? '';
                                        this.setState((prevState) => ({
                                            commentTextMap: {
                                                ...prevState.commentTextMap,
                                                [title]: value,
                                            },
                                        }));
                                    }}
                                    autoSize={{ minRows: 2 }}
                                    style={{ marginBottom: '10px' }}
                                />
                                <Button
                                    type="primary"
                                    icon={<i className="fa fa-save" />}
                                    disabled={
                                        !this.state.selectedFactNameMap?.[title] ||
                                        !this.state.commentTextMap?.[title]
                                    }
                                    onClick={() => this.handleCommentSubmit(title)}
                                >
                                    {this.state.editInfo && this.state.editInfo.title === title ? 'Update' : 'Save'}
                                </Button>
                                <div style={{ marginTop: 20, maxHeight: 300, overflowY: 'auto' }}>
                                    {(this.state.submittedComments?.[title] || []).map((entry, commentIndex) => (
                                        <div
                                            key={commentIndex}
                                            style={{
                                                border: '1px solid #f0f0f0',
                                                borderRadius: 8,
                                                padding: 16,
                                                marginBottom: 20,
                                                backgroundColor: '#fff',
                                                boxShadow: '0 2px 6px rgba(0, 0, 0, 0.03)'
                                            }}
                                        >
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <div>
                                                    <div style={{ fontWeight: 600, fontSize: 16, color: '#262626' }}>{Array.isArray(entry.factName) ? entry.factName.join(" | ") : entry.factName}</div>
                                                    <div style={{ marginTop: 6, fontSize: 14, color: '#595959' }}>{entry.comment}</div>
                                                    <div style={{ display: 'flex', gap: '16px', fontSize: 12, color: '#888', marginTop: 4 }}>
                                                        <div style={{ fontSize: 12, color: '#8c8c8c', marginTop: 6 }}>— {entry?.created_by}</div>
                                                        {entry?.created_at && <div style={{ fontSize: 12, color: '#bfbfbf', marginTop: 4 }}>
                                                            🕒 {entry?.created_at}
                                                        </div>}
                                                    </div>
                                                </div>
                                                <div style={{ textAlign: 'right' }}>
                                                    {entry?.user_id == this.props.user && (<Icon
                                                        type="edit"
                                                        onClick={() => this.handleEditComment(title, commentIndex)}
                                                        style={{ cursor: 'pointer', color: '#1890ff' }}
                                                    />)}
                                                    {!entry.replies?.length && (
                                                        <div
                                                            onClick={() => this.setState({ activeReply: { title, commentIndex }, replyText: '' })}
                                                            style={{ cursor: 'pointer', color: '#1890ff', fontSize: 13, marginTop: 8 }}
                                                        >
                                                            Reply
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {(entry.replies || []).length > 0 && (
                                                <div style={{ marginTop: 16, paddingLeft: 16, borderLeft: '3px solid #e6f7ff', backgroundColor: '#fafafa', borderRadius: 4 }}>
                                                    {entry.replies.map((r, replyIndex) => (
                                                        <div key={replyIndex} style={{ marginBottom: 10 }}>
                                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                <div>
                                                                    <span style={{ color: '#4a4a4a' }}>↳ {r.reply}</span>
                                                                    <div style={{ display: 'flex', gap: '16px', fontSize: 12, color: '#888', marginTop: 4 }}>
                                                                     <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>— {r?.created_by_name}</div>
                                                                     {r?.created_at && <div style={{ fontSize: 12, color: '#bfbfbf', marginTop: 4 }}>
                                                                         🕒 {r?.created_at}
                                                                     </div>}
                                                                    </div>
                                                                </div>
                                                                {r?.user_id == this.props.user && (<Icon
                                                                    type="edit"
                                                                    onClick={() => this.handleEditReply(title, commentIndex, replyIndex, r.reply)}
                                                                    style={{ cursor: 'pointer', color: '#52c41a' }}
                                                                />)}
                                                            </div>
                                                        </div>
                                                    ))}
                                                    <div
                                                        onClick={() => this.setState({ activeReply: { title, commentIndex }, replyText: '' })}
                                                        style={{ cursor: 'pointer', color: '#1890ff', fontSize: 13, marginTop: 6 }}
                                                    >
                                                        Reply
                                                    </div>
                                                </div>
                                            )}

                                            {this.state.activeReply?.title === title &&
                                                this.state.activeReply?.commentIndex === commentIndex && (
                                                    <div style={{ marginTop: 12 }}>
                                                        <Input.TextArea
                                                            rows={2}
                                                            value={this.state.replyTexts?.[`${commentIndex}_${title}`] || ''}
                                                            onChange={(e) => this.handleReplyInputChange(e, title, commentIndex)}
                                                            placeholder="Write a reply..."
                                                            style={{ marginBottom: 6, borderRadius: 4 }}
                                                        />
                                                        <span ref={this.updateReplyButtonRef}>
                                                            <Button
                                                                size="small"
                                                                type="primary"
                                                                onClick={() => this.handleReplySubmit(title, commentIndex)}
                                                                disabled={!this.state.replyTexts?.[`${commentIndex}_${title}`]}
                                                            >
                                                                {this.state.replyEditInfo?.title === title &&
                                                                    this.state.replyEditInfo?.commentIndex === commentIndex
                                                                    ? 'Update Reply'
                                                                    : 'Reply'}
                                                            </Button>
                                                        </span>
                                                    </div>
                                                )}
                                        </div>
                                    ))}
                                </div>

                            </Card>
                        </div>
                    ))}
                </Spin>
            </>
        );
    }
}

CAMViewNew.propTypes = {
    caseId: PropTypes.number,
    camEngineData: PropTypes.object,
    fetchCamEngineView: PropTypes.func,
    fetchCaseDetail: PropTypes.func
};


export default CAMViewNew;